var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-outline-primary finish-button",on:{"click":_vm.finishConfiguration}},[_vm._v(" Finish configuration ")])
}
var staticRenderFns = []

export { render, staticRenderFns }